import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getCustomerEventSelectedProducts } from "@src/store/slices/customEvents";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";

export const openCustomEventsProductPicker = createAsyncThunk<void, void>(
  "productPicker/openCustomEventsProductPicker",
  async (_, { dispatch, getState }) => {
    dispatch(openProductPicker({ type: "customEvents" }));

    const selectedProducts = getCustomerEventSelectedProducts(getState());
    dispatch(setProductPickerSelectedProducts(selectedProducts));
  }
);
